import { Component, OnInit } from '@angular/core';
import { CorePageBaseComponent } from '../../shared/core-page-base.component';
import { PageInstance } from '@workflow/class/page.service';

@Component({
  selector: 'cu-dynamic-page-review',
  templateUrl: './dynamic-page-review.component.html'
})
export class DynamicPageReviewComponent extends CorePageBaseComponent implements OnInit {
  ngOnInit() {}

  /**
   * In case we have multiple review page:
   * if page config has reviewPageIds properties, this function will check if this current review page is the related review page
   * Example: assume we have two review pages: 'review-page1' and 'review-page2'
   * if pageA.config.reviewPageIds is set to ['review-page1'], we want to make sure pageA will be shown only in review-page1
   * @param page the page to render in review mode
   */
  isMyReviewContainer(pageToReview: PageInstance) {
    if (this.hasReviewPageId(pageToReview)) {
      const currentReviewPage = this.page;
      return pageToReview.reviewPageIds.includes(currentReviewPage.id);
    }
    return true;
  }

  private hasReviewPageId(page: PageInstance) {
    return page.reviewPageIds?.length > 0;
  }
}
